import React from 'react';
import PropTypes from 'prop-types';

import Picture from '../../Util/Picture/Picture';
import Slider from '../../Util/Slider/SliderView';

// import assets
import './productSliderMobileModule.scss';


const sliderSettings = {
  dots: true,
  dotsClass: 'lines',
  accessibility: true,
  variableWidth: false,
  centerMode: false,
  infinite: false,
  vertical: false,
  initialSlide: 0,
  centerPadding: '0px',
  arrows: false,
  adaptiveHeight: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
};

const ProductSliderModuleDesktopView = props => (
  <div className="m-article-module m-article-module--wide m-article-module--grey-gradient">
    <div className={'m-product-slider-module'}>
      <Slider sliderSettings={sliderSettings}>
        {props.slideModules.map(product => (
          <div className="m-product-slider-module__slide" key={Math.random()}>
            <div className={'m-product-slider-module__productimage'}>
              <Picture
                src={product.src}
                alt={product.alt}
                className={'m-product-slider-module__image'}
                disableZoom
              />
            </div>
            <div className={'m-product-slider-module__textwrapper'}>
              <div className={'m-product-slider-module__headsub'}>
                <div className={'m-product-slider-module__product-headline'}>
                  {product.headline}
                </div>
                <div className={'m-product-slider-module__product-subline'}>
                  {product.subline}
                </div>
              </div>
              <div className={'m-product-slider-mobile__copytextbutton'}>
                <div className="m-product-slider-module__product-copy">
                  {product.copy}
                </div>
                <a href={product.buttonTarget} className="a-button a-button--blue a-button--blue">
                  {product.buttonLabel}
                </a>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  </div>
);


ProductSliderModuleDesktopView.propTypes = {
  slideModules: PropTypes.arrayOf(PropTypes.shape()),
};

ProductSliderModuleDesktopView.defaultProps = {
  slideModules: [],
};

export default ProductSliderModuleDesktopView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/ProductSliderModule/ProductSliderModuleDesktopView.jsx